var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 55,
    viewBox: "0 0 65 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2032_863)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.03 54.97H0.65C0.29 54.97 0 54.68 0 54.32V0.65C0 0.29 0.29 0 0.65 0H35.75C35.92 0 36.09 0.07 36.21 0.19L46.53 10.51C46.65 10.63 46.72 10.8 46.72 10.97V24.29C46.72 24.65 46.43 24.94 46.07 24.94C45.71 24.94 45.42 24.65 45.42 24.29V11.23L35.48 1.29H1.29V53.68H23.03C23.39 53.68 23.68 53.97 23.68 54.33C23.68 54.69 23.39 54.98 23.03 54.98V54.97Z",
    fill: "#74263D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0701 11.6104H35.7501C35.3901 11.6104 35.1001 11.3204 35.1001 10.9604V0.650377C35.1001 0.390377 35.2601 0.150377 35.5001 0.0503767C35.7401 -0.0496233 36.0201 0.000376686 36.2001 0.190377L46.5201 10.5104C46.7001 10.6904 46.7601 10.9704 46.6601 11.2104C46.5601 11.4504 46.3201 11.6104 46.0601 11.6104H46.0701ZM36.3901 10.3204H44.5101L36.3901 2.20038V10.3204Z",
    fill: "#74263D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4902 11.6096H7.87021C7.51021 11.6096 7.22021 11.3196 7.22021 10.9596C7.22021 10.5996 7.51021 10.3096 7.87021 10.3096H27.4802C27.8402 10.3096 28.1302 10.5996 28.1302 10.9596C28.1302 11.3196 27.8402 11.6096 27.4802 11.6096H27.4902Z",
    fill: "#74263D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2302 16.7795H7.87021C7.51021 16.7795 7.22021 16.4895 7.22021 16.1295C7.22021 15.7695 7.51021 15.4795 7.87021 15.4795H19.2302C19.5902 15.4795 19.8802 15.7695 19.8802 16.1295C19.8802 16.4895 19.5902 16.7795 19.2302 16.7795Z",
    fill: "#74263D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8402 16.7795H23.3502C22.9902 16.7795 22.7002 16.4895 22.7002 16.1295C22.7002 15.7695 22.9902 15.4795 23.3502 15.4795H38.8402C39.2002 15.4795 39.4902 15.7695 39.4902 16.1295C39.4902 16.4895 39.2002 16.7795 38.8402 16.7795Z",
    fill: "#74263D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5202 21.9396H7.87021C7.51021 21.9396 7.22021 21.6496 7.22021 21.2896C7.22021 20.9296 7.51021 20.6396 7.87021 20.6396H28.5202C28.8802 20.6396 29.1702 20.9296 29.1702 21.2896C29.1702 21.6496 28.8802 21.9396 28.5202 21.9396Z",
    fill: "#74263D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.84 21.9396H32.65C32.29 21.9396 32 21.6496 32 21.2896C32 20.9296 32.29 20.6396 32.65 20.6396H38.84C39.2 20.6396 39.49 20.9296 39.49 21.2896C39.49 21.6496 39.2 21.9396 38.84 21.9396Z",
    fill: "#74263D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1002 27.0998H7.87021C7.51021 27.0998 7.22021 26.8098 7.22021 26.4498C7.22021 26.0898 7.51021 25.7998 7.87021 25.7998H15.1002C15.4602 25.7998 15.7502 26.0898 15.7502 26.4498C15.7502 26.8098 15.4602 27.0998 15.1002 27.0998Z",
    fill: "#74263D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8401 27.0998H19.2301C18.8701 27.0998 18.5801 26.8098 18.5801 26.4498C18.5801 26.0898 18.8701 25.7998 19.2301 25.7998H38.8401C39.2001 25.7998 39.4901 26.0898 39.4901 26.4498C39.4901 26.8098 39.2001 27.0998 38.8401 27.0998Z",
    fill: "#74263D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4502 37.4191H7.87021C7.51021 37.4191 7.22021 37.1291 7.22021 36.7691C7.22021 36.4091 7.51021 36.1191 7.87021 36.1191H26.4502C26.8102 36.1191 27.1002 36.4091 27.1002 36.7691C27.1002 37.1291 26.8102 37.4191 26.4502 37.4191Z",
    fill: "#74263D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1602 44.6496H7.87021C7.51021 44.6496 7.22021 44.3596 7.22021 43.9996C7.22021 43.6396 7.51021 43.3496 7.87021 43.3496H17.1602C17.5202 43.3496 17.8102 43.6396 17.8102 43.9996C17.8102 44.3596 17.5202 44.6496 17.1602 44.6496Z",
    fill: "#74263D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3202 32.26H7.87021C7.51021 32.26 7.22021 31.97 7.22021 31.61C7.22021 31.25 7.51021 30.96 7.87021 30.96H22.3202C22.6802 30.96 22.9702 31.25 22.9702 31.61C22.9702 31.97 22.6802 32.26 22.3202 32.26Z",
    fill: "#74263D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5398 54.98H28.3598C28.1198 54.98 27.8998 54.85 27.7898 54.63C27.6798 54.41 27.6998 54.16 27.8398 53.96L45.4298 29.13C45.6698 28.79 46.2398 28.79 46.4898 29.13L64.0798 53.96C64.2198 54.16 64.2398 54.42 64.1298 54.63C64.0198 54.85 63.7998 54.98 63.5598 54.98H63.5398ZM29.6098 53.69H62.2898L45.9498 30.62L29.6098 53.69Z",
    fill: "#74263D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9498 46.7001C45.5898 46.7001 45.2998 46.4101 45.2998 46.0501V37.7701C45.2998 37.4101 45.5898 37.1201 45.9498 37.1201C46.3098 37.1201 46.5998 37.4101 46.5998 37.7701V46.0501C46.5998 46.4101 46.3098 46.7001 45.9498 46.7001Z",
    fill: "#74263D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9499 51.2202C46.5188 51.2202 46.9799 50.759 46.9799 50.1902C46.9799 49.6213 46.5188 49.1602 45.9499 49.1602C45.3811 49.1602 44.9199 49.6213 44.9199 50.1902C44.9199 50.759 45.3811 51.2202 45.9499 51.2202Z",
    fill: "#74263D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2032_863"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.18,
    height: 54.98,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4);
export default __webpack_public_path__ + "static/media/step4.ada4af38a2c7cb06c4df1ebde6f54fee.svg";
export { ForwardRef as ReactComponent };